import TypeError from '.TypeError';

import * as is from './is';
import * as TOKEN from './TOKEN';
import Layer, { protect } from './Layer';
import Url, { newUrl } from './Url';
import IdSelector from './IdSelector';
import AttributeSelector from './AttributeSelector';

export default class Parenthesis extends Layer                                                                                             {
	
	get [Symbol.toStringTag] () { return 'Parenthesis'; }
	
	                 nameLiteral        ;
	
	constructor (nameLiteral         ) {
		super();
		this.nameLiteral = nameLiteral || '';
		return this;
	}
	
	[TOKEN.consume] (                 ) {
		switch ( TOKEN.type ) {
			case TOKEN.whitespace:
				this.length && ( this.newItem = ' ' );
				return this;
			case TOKEN.function_:
				return this.newItem = is.url_ (TOKEN.literal)
					? new Url(TOKEN.literal.slice(0, 3))
					: new Parenthesis(TOKEN.literal.slice(0, -1));
			case '(':
				return this.newItem = new Parenthesis;
			case '[':
				return null;
			case ')':
				const { lastItem } = this;
				( lastItem===' ' || lastItem==='/**/' ) && --this.length;
				if ( !this.length ) { return null; }
				return this[TOKEN.parent];
			case TOKEN.comment:
				this.length && ( this.newItem = '/**/' );
				return this;
			case TOKEN.hash:
			case TOKEN.string:
			case TOKEN.percentage:
			case '!':
			case '$':
			case '-':
			case '/':
			case '?':
			case TOKEN.ident:
			case TOKEN.number:
			case TOKEN.dimension:
			case '*':
			case '+':
			case ',':
			case '.':
			case ':':
			case '>':
			case '|':
			case '~':
				this.newItem = TOKEN.literal;
				return this;
			case TOKEN.url:
				if ( TOKEN.literal[3]==='(' ) { return newUrl(this); }
				return null;
			/*
			case ']':
			case '{':
			case '}':
			case '`':
			case '^':
			case '@':
			case '<':
			case '=':
			case ';':
			case '&':
			case '%':
			case TOKEN.atKeyword:
			*/
		}
		return null;
	}
	
	[Symbol.toPrimitive] (                 ) {
		return `${this.nameLiteral}(${this.join('')})`;
	}
	
	* [Symbol.iterator] (                 ) { throw TypeError(`beautify parenthesis`); }
	
	static default = protect(this);
	
};

                                               
                                                 